import { vars } from '@repo/config';
import type { IUsersListResponse } from '../types/i-users-list-response';
import { createGetFetchOptions } from './helper';

export async function searchUsersByEmail(
  cookieHeader: string,
  email: string,
): Promise<IUsersListResponse | null> {
  const usersUrl = new URL('/api/auth/admin/list-users', vars.url.identityUrl);
  usersUrl.searchParams.set('filterField', 'email');
  usersUrl.searchParams.set('filterValue', email);
  usersUrl.searchParams.set('filterOperator', 'contains');

  const response = await fetch(usersUrl.toString(), createGetFetchOptions({ cookieHeader }));

  if (!response.ok) {
    return null;
  }

  return (await response.json()) as IUsersListResponse;
}
